import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) {
      return;
    }
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => {
        setUser(data);
        nav(data.profile_complete ? "/discover" : "/onboarding", { replace: true });
      })
      .catch((e) => {
        toast.error(errMsg(e));
        setUser(false);
        nav("/login", { replace: true });
      });
  }, [location.hash, nav, setUser]);

  return null;
}
